/* (c) Copyright Frontify Ltd., all rights reserved. */

export const BLUR_ON_BREAK_PLUGIN = 'blur-on-break-plugin';
